import type { OrderId} from "../orders/order-id";
import { orderIdZodSchema } from "../orders/order-id";

type MessageOwnerId = OrderId;

const messageOwnerIdZodSchema = orderIdZodSchema;

export { messageOwnerIdZodSchema };
export type { MessageOwnerId };
